import { Injectable } from '@angular/core';
import { ReportTypeType, ReportType } from '../constants-types/Enums';
import { StringUtilities } from '../core-utilities/String.utility';
import { TranslationService } from '../translations';

@Injectable({ providedIn: 'root' })
export class ReportUtilities {
    constructor(
        private TR: TranslationService,
        private stringUtil: StringUtilities
    ) {}

    getReportName(reportType: ReportTypeType) {
        return this.TR.key(reportType.reportFilename);
    }

    /**
     * Truly unfortunate that firstName and lastName are nullable, but
     * this is the easiest way to shove in a AbstractReportReceiver,
     * which doesn't require the fields firstName and lastName
     */
    getPersonReportName(
        reportType: ReportTypeType,
        person1: { firstName?: string; lastName?: string },
        person2: { firstName?: string; lastName?: string } = null
    ) {
        if (reportType === ReportType.RelationshipGuide) {
            return this.stringUtil.formatString(
                this.TR.key(reportType.reportFilename),
                person1.lastName,
                person2.lastName
            );
        } else {
            return this.stringUtil.formatString(
                this.TR.key(reportType.reportFilename),
                person1.lastName,
                person1.firstName
            );
        }
    }

    /**
     * Generates a name for the zip file that will be downloaded.
     * The name includes the person's first and last name, and a header
     * without the presence of any special characters.
     */
    getSanitizedPersonFileName(
        firstName: string,
        lastName: string,
        reportName: string
    ) {
        return `${firstName}_${lastName}_${this.TR.key(reportName)}`.replaceAll(
            /[<>:"/\\|?*.]+/g,
            ''
        );
    }
}
